import { render, staticRenderFns } from "./MultiDataBarchart.vue?vue&type=template&id=00522578&"
import script from "./MultiDataBarchart.vue?vue&type=script&lang=js&"
export * from "./MultiDataBarchart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports